export default __webpack_public_path__ + "static/literature-reference-tablet-27659989a245063b41d77fbc61965c20.png";